/**
 * 여행지(DESTINATION_CITIES)의 흔한 다른 표기·하위 지명 — 생성 파일, 직접 고치지 말 것(10-19).
 * 위치 검색에만 쓰인다. 공용 번들에서 빼려고 역 사전과 같이 지연 등록한다
 * (lib/search/station-places · station-places.eager).
 */
export const DESTINATION_ALIASES: Record<string, string[]> = {
  "JP-TAM": ["다마 지역", "하치오지", "八王子", "Hachioji", "다카오산", "高尾山", "Mount Takao", "Takao", "오쿠타마", "奥多摩", "Okutama", "다치카와", "立川", "Tachikawa", "마치다", "町田", "Machida", "후추", "府中", "다마시", "多摩市", "다마", "Tama", "多摩", "다카오", "히노", "日野", "Hino"],
  "JP-HKN": ["箱根町", "오다와라", "小田原", "Odawara", "유가와라", "湯河原", "Yugawara", "아시노코", "芦ノ湖", "Lake Ashi", "하코네유모토", "箱根湯本", "하코네정"],
  "JP-KMK": ["鎌倉市", "즈시", "逗子", "Zushi", "하야마", "葉山", "Hayama", "가마쿠라시", "镰仓市"],
  "JP-SHN": ["쇼난 해안", "에노시마", "江の島", "江ノ島", "Enoshima", "후지사와", "藤沢", "Fujisawa", "지가사키", "茅ヶ崎", "Chigasaki", "히라쓰카", "平塚", "Hiratsuka", "오이소", "大磯", "Oiso"],
  "JP-YKS": ["横須賀市", "미우라", "三浦", "Miura", "미우라반도", "三浦半島", "Miura Peninsula", "요코스카시", "横须贺市", "橫須賀市"],
  "JP-KWS": ["川崎市", "Kawasaki City", "무사시코스기", "武蔵小杉", "가와사키시"],
  "JP-SGM": ["相模原市", "사가미코", "相模湖", "Lake Sagami", "하시모토", "橋本", "사가미하라시"],
  "JP-FFL": ["후지 5호", "후지산", "富士山", "Mount Fuji", "Mt Fuji", "Lake Kawaguchi", "야마나카코", "山中湖", "Yamanakako", "후지요시다", "富士吉田", "Fujiyoshida", "오시노핫카이", "忍野八海", "후지고코", "Fuji Five Lakes", "富士五湖", "가와구치 호수", "Lake Kawaguchiko", "fuji", "mt-fuji"],
  "JP-FJN": ["富士宮市", "아사기리고원", "朝霧高原", "Asagiri", "다누키코", "田貫湖", "후지시", "富士市", "후지노미야시", "富士宫市"],
  "JP-GTB": ["御殿場市", "Gotenba", "고텐바 아울렛", "御殿場アウトレット", "스소노", "裾野", "Susono", "고텐바시", "御殿场市"],
  "JP-YTG": ["야츠가타케", "八ヶ岳高原", "호쿠토", "北杜", "Hokuto", "기요사토", "清里", "Kiyosato", "고부치자와", "小淵沢", "Kobuchizawa"],
  "JP-NSU": ["나스고원", "那須高原", "Nasu Kogen", "나스시오바라", "那須塩原", "Nasushiobara", "시오바라 온천", "塩原温泉", "나스정", "那須町", "那须町"],
  "JP-NIK": ["日光市", "Nikkō", "기누가와", "鬼怒川", "Kinugawa", "주젠지호", "中禅寺湖"],
  "JP-KRZ": ["軽井沢町", "가루이자와 아울렛", "미요타", "御代田", "가루이자와정", "轻井泽町", "輕井澤町"],
  "JP-KST": ["구사츠", "草津温泉", "Kusatsu Onsen", "구사쓰 온천", "구사쓰정", "草津町"],
  "JP-MKM": ["水上温泉", "미나카미 온천", "다니가와다케", "谷川岳", "누마타", "沼田", "오제", "尾瀬", "Oze", "가타시나", "片品", "미나카미정", "みなかみ町", "水上町"],
  "JP-CCB": ["치치부", "秩父市", "나가토로", "長瀞", "Nagatoro", "지치부시"],
  "JP-KWG": ["川越市", "작은 에도", "小江戸", "가와고에시"],
  "JP-NRT": ["나리타공항", "成田空港", "Narita Airport", "NRT", "成田市", "나리타시", "나리타 공항", "narita-airport", "成田机场", "成田機場"],
  "JP-ATM": ["熱海市", "아타미 온천", "熱海温泉", "아타미시", "热海市"],
  "JP-IZU": ["이즈반도", "伊豆半島", "Izu Peninsula", "이토", "伊東", "Ito", "시모다", "下田", "Shimoda", "슈젠지", "修善寺", "Shuzenji", "아타가와", "熱川", "伊豆半岛"],
  "JP-MMJ": ["마츠모토", "松本市", "가미코치", "上高地", "Kamikochi", "아즈미노", "安曇野", "Azumino", "마쓰모토시"],
  "JP-HKB": ["白馬村", "하쿠바 스키", "오타리", "小谷", "오마치", "大町", "하쿠바촌", "白马村"],
  "JP-NSK": ["ニセコ町", "新雪谷", "新雪谷町", "굿찬", "倶知安", "Kutchan", "히라후", "ヒラフ", "Hirafu", "란코시", "蘭越", "니세코정"],
  "JP-OTR": ["小樽市", "오타루 운하", "小樽運河", "오타루시"],
  "JP-FRN": ["富良野市", "가미후라노", "上富良野", "나카후라노", "中富良野", "팜 도미타", "후라노시"],
  "JP-BIE": ["美瑛町", "청의 호수", "青い池", "Blue Pond", "비에이정"],
  "JP-AKJ": ["旭川市", "아사히야마 동물원", "旭山動物園", "아사히카와시"],
  "JP-HKD": ["函館市", "하코다테야마", "函館山", "하코다테시", "函馆市"],
  "JP-NBT": ["노보리베츠", "登別温泉", "Noboribetsu Onsen", "노보리베쓰시", "登別市", "登别市"],
  "JP-TOY": ["도야코", "洞爺湖温泉", "Toyako", "Lake Toya Onsen"],
  "JP-SRT": ["知床半島", "우토로", "ウトロ", "Utoro", "샤리", "斜里", "라우스", "羅臼"],
  "JP-KUH": ["釧路市", "구시로 습원", "釧路湿原", "구시로시", "钏路市"],
  "JP-SDJ": ["仙台市", "마쓰시마", "松島", "Matsushima", "센다이시", "仙臺市"],
  "JP-KNZ": ["金沢市", "겐로쿠엔", "兼六園", "가나자와시", "金泽市", "金澤市"],
  "JP-TKY": ["히다다카야마", "飛騨高山", "Hida-Takayama", "高山市", "다카야마시"],
  "JP-SRK": ["시라카와", "白川村", "Shirakawago", "Shirakawa-gō"],
  "JP-ISE": ["이세", "伊勢", "Ise", "이세신궁", "伊勢神宮", "도바", "鳥羽", "Toba", "시마", "志摩", "이세시", "伊勢市", "伊势市"],
  "JP-SRH": ["난키시라하마", "南紀白浜", "Nanki-Shirahama", "白浜町", "시라하마정", "白滨町", "白濱町"],
  "JP-KNS": ["기노사키 온천", "城崎温泉", "Kinosaki Onsen", "도요오카", "豊岡"],
  "JP-HMJ": ["姫路市", "히메지성", "姫路城", "히메지시", "姬路市"],
  "JP-AWJ": ["아와지", "淡路", "Awaji", "스모토", "洲本", "미나미아와지", "南あわじ"],
  "JP-KUR": ["倉敷市", "구라시키 미관지구", "倉敷美観地区", "구라시키시", "仓敷市"],
  "JP-IZM": ["出雲市", "이즈모타이샤", "出雲大社", "이즈모시", "出云市"],
  "JP-ITK": ["이쓰쿠시마", "厳島", "Itsukushima", "하쓰카이치", "廿日市", "Hatsukaichi", "이쓰쿠시마섬", "严岛", "嚴島"],
  "JP-TAK": ["다카마츠", "高松市", "리쓰린 공원", "栗林公園", "다카마쓰시"],
  "JP-NAO": ["直島町", "데시마", "豊島", "Teshima", "나오시마정", "直岛町"],
  "JP-MYJ": ["마츠야마", "松山市", "도고온천", "道後温泉", "Dogo Onsen", "마쓰야마시"],
  "JP-KKJ": ["北九州市", "모지코", "門司港", "Mojiko", "고쿠라", "小倉", "Kokura"],
  "JP-SSB": ["佐世保市", "하우스텐보스", "ハウステンボス", "Huis Ten Bosch", "사세보시"],
  "JP-BPU": ["別府市", "벳푸 온천", "別府温泉", "지옥 순례", "地獄めぐり", "벳푸시", "别府市"],
  "JP-YFN": ["유후", "湯布院", "由布市", "Yufu", "유후인 온천", "유후시"],
  "JP-ASO": ["阿蘇市", "아소산", "阿蘇山", "Mount Aso", "구로카와 온천", "黒川温泉", "아소시", "阿苏市"],
  "JP-YKU": ["屋久島町", "야쿠섬"],
  "JP-ASJ": ["아마미", "奄美", "Amami", "奄美市", "Amami Ōshima"],
  "JP-OKA": ["那覇市", "나하공항", "那覇空港", "Naha Airport", "국제거리", "国際通り", "Kokusai-dori", "도미구스쿠", "豊見城", "나하시", "那霸市"],
  "JP-CTN": ["北谷町", "아메리칸 빌리지", "美浜アメリカンビレッジ", "American Village", "기노완", "宜野湾", "Ginowan", "자탄정"],
  "JP-ONN": ["恩納村", "만좌모", "万座毛", "요미탄", "読谷", "Yomitan", "온나촌", "恩纳村", "온나", "Onna Village"],
  "JP-MTB": ["本部町", "추라우미 수족관", "美ら海水族館", "Churaumi", "나고", "名護", "Nago", "나키진", "今帰仁", "고우리섬", "古宇利島", "Kouri Island", "모토부정"],
  "KR-GNG": ["강릉시", "경포대", "안목해변", "注文津", "주문진", "江陵市"],
  "KR-SKC": ["속초시", "설악산", "雪嶽山", "Seoraksan", "양양", "襄陽", "Yangyang", "束草市"],
  "KR-GYJ": ["경주시", "불국사", "佛國寺", "Bulguksa", "황리단길", "慶州市", "庆州市"],
  "KR-YSU": ["여수시", "여수 밤바다", "오동도", "麗水市", "丽水市"],
  "KR-SGP": ["서귀포시", "西帰浦市", "西归浦市"],
  "KR-TYG": ["통영시", "거제", "巨済", "Geoje", "統営市", "统营市", "巨濟"],
  "KR-GPY": ["가평군", "남이섬", "南怡島", "Nami Island", "쁘띠프랑스", "Gapyeong County", "加平郡"],
  "KR-PYC": ["평창군", "알펜시아", "Alpensia", "용평", "龍平", "Yongpyong", "Pyeongchang County", "平昌郡"],
  "KR-CHC": ["춘천시", "레고랜드", "Legoland Korea", "春川市"],
  "KR-AND": ["안동시", "하회마을", "河回村", "Hahoe", "安東市"],
  "KR-SCN": ["순천시", "순천만", "順天湾", "順天市"],
  "KR-POH": ["포항시", "호미곶", "영일대", "浦項市"],
  "TW-JFN": ["주펀", "Jioufen", "루이팡", "瑞芳", "Ruifang", "진과스", "金瓜石"],
  "TW-TAM": ["淡水老街", "Danshui", "단수이 라오제", "단수이구", "Tamsui District", "淡水区", "淡水區", "담수이"],
  "TW-XLQ": ["류추", "琉球嶼", "Lambai Island", "Liuqiu"],
  "TW-GRI": ["녹도", "綠島鄉", "Lyudao", "Ludao", "뤼다오 섬"],
  "TW-OKY": ["난서", "Lanyu", "蘭嶼鄉", "란위섬"],
  "TW-TRK": ["타이루거 협곡", "太魯閣峽谷", "Taroko Gorge", "타이루거 국가공원", "Taroko National Park", "太魯閣国家公園", "太鲁阁国家公园", "太魯閣國家公園", "타로코", "太魯閣峡谷"],
  "TW-BTO": ["北投溫泉", "베이터우 온천", "Beitou Hot Spring", "베이터우구", "Beitou District", "北投区", "北投區"],
  "TW-WLA": ["烏來溫泉", "우라이 온천", "우라이구", "Wulai District", "烏来区", "乌来区", "烏來區"],
  "TW-JXI": ["礁溪溫泉", "자오시 온천", "자오시향", "Jiaoxi Township", "礁渓郷", "礁溪乡", "礁溪鄉", "礁溪温泉"],
  "HK-LAN": ["란터우", "Lantau", "Ngong Ping", "昂坪", "Tung Chung", "東涌", "디즈니랜드 홍콩", "란터우섬"],
  "HK-SKG": ["사이궁", "Sai Kung Town", "西貢區", "시궁구", "Sai Kung District", "西貢区", "西贡区"],
  "MO-MFM": ["Macao", "마카우", "코타이", "路氹", "Cotai", "타이파", "氹仔", "Taipa"],
  "TH-USM": ["사무이", "Samui", "Ko Samui", "차웽", "Chaweng", "사무이섬", "沙湄岛", "沙湄島"],
  "TH-PGN": ["팡안", "Ko Pha Ngan", "Phangan", "팡안섬", "Ko Pha-ngan", "パナガン島"],
  "TH-KTO": ["꼬따오", "따오섬", "Ko Tao", "阁道岛"],
  "TH-KCH": ["꼬창", "Ko Chang", "창섬"],
  "TH-LNT": ["꼬란따", "Ko Lanta", "란타"],
  "TH-PPI": ["피피", "Koh Phi Phi", "Phi Phi", "꼬피피", "ピーピー諸島", "小皮皮岛"],
  "TH-AYU": ["Ayuthaya", "아유타야 유적", "Phra Nakhon Si Ayutthaya", "テーサバーンナコーン・プラナコーンシーアユッタヤー", "阿瑜陀耶"],
  "TH-KAN": ["콰이강", "River Kwai", "깐짜나부리"],
  "TH-CEI": ["백색사원", "White Temple", "쨍라이"],
  "TH-PAI": ["Pai District", "파이"],
  "TH-SKT": ["수코타이 역사공원"],
  "TH-KLG": ["Khaolak", "카오락 해변", "까오락", "镐立", "鎬立"],
  "VN-PQC": ["Phú Quốc", "푸코옥", "즈엉동", "Duong Dong", "푸꾸옥섬"],
  "VN-DLI": ["Đà Lạt", "Dalat", "다랏"],
  "VN-SPA": ["Sapa", "판시판", "Fansipan"],
  "VN-HLB": ["하롱", "Ha Long", "Hạ Long", "Halong Bay", "下龍", "하롱 만"],
  "VN-NBH": ["Ninh Bình", "짱안", "Tràng An", "Trang An", "땀꼭", "Tam Coc"],
  "VN-MUI": ["Mũi Né", "판티엣", "Phan Thiết", "Phan Thiet"],
  "VN-VTU": ["Vũng Tàu", "붕타우"],
  "VN-UIH": ["Quy Nhơn", "퀴논"],
  "VN-VCS": ["Côn Đảo", "곤다오", "Con Son", "崑崙島"],
  "VN-PHN": ["퐁냐께방", "Phong Nha-Ke Bang", "동허이", "Đồng Hới"],
  "PH-PNG": ["팡라오", "Panglao", "Panglao Island", "초콜릿 힐", "Chocolate Hills", "타그빌라란", "Tagbilaran"],
  "PH-ENI": ["엘 니도"],
  "PH-USU": ["Coron Island", "부수앙가", "Busuanga"],
  "PH-PPS": ["푸에르토 프린세사", "지하강", "Underground River", "普林塞萨港"],
  "PH-IAO": ["Siargao Island", "제너럴 루나", "General Luna", "클라우드 나인", "Cloud 9", "シアルガオ"],
  "PH-BAG": ["바기오시", "Baguio City"],
  "PH-TAG": ["따가이따이", "타알 화산", "Taal Volcano", "塔盖泰", "大雅臺"],
  "PH-CRK": ["앙헬레스", "Angeles City", "Angeles", "Clark Freeport", "클라크"],
  "PH-DGT": ["두마게테", "아포섬", "Apo Island", "朗芒芽地"],
  "ID-UBD": ["우부드", "몽키 포레스트", "Monkey Forest", "乌布市场"],
  "ID-SMY": ["세미냑", "레기안", "Legian"],
  "ID-CGU": ["창구", "Changgu"],
  "ID-KUT": ["쿠타", "Kuta Beach", "꾸따 비치"],
  "ID-NSD": ["누사 두아", "짐바란", "Jimbaran"],
  "ID-NPN": ["페니다", "Penida", "누사 렘봉안", "Nusa Lembongan"],
  "ID-LOP": ["Lombok Island", "롬복섬", "마타람", "Mataram", "꾸따 롬복"],
  "ID-GLI": ["길리 트라왕안", "Gili Trawangan", "길리 메노", "Gili Meno", "길리 아이르", "Gili Air", "길리 제도"],
  "ID-LBJ": ["코모도", "Komodo", "Komodo National Park", "라부안 바조", "ラブハンバジョ"],
  "ID-BTH": ["바탐섬", "Batam Island", "バタム", "巴淡"],
  "ID-BIN": ["빈탄섬", "Bintan Island", "라군 빈탄", "Lagoi"],
  "MY-LGK": ["Langkawi Island", "랑카위섬", "쿠아", "Kuah", "판타이 체낭", "Pantai Cenang", "ランカウイ島", "浮羅交怡"],
  "MY-CMH": ["카메론 하이랜드", "Tanah Rata", "타나라타", "Cameron Highlands District"],
  "MY-GTG": ["겐팅", "Genting", "雲頂", "겐팅 하일랜즈", "ゲンティンハイランド"],
  "MY-KCH": ["쿠칭시", "Kuching City"],
  "MY-IPH": ["이포시"],
  "MY-TOD": ["티오만", "Tioman", "Pulau Tioman"],
  "SG-SEN": ["센토사섬", "Sentosa Island", "유니버설 스튜디오 싱가포르"],
  "GU-GUM": ["투몬", "Tumon", "タモン", "하갓냐", "Hagåtña", "Hagatna", "タモン湾"],
  "MP-SPN": ["사이판섬", "가라판", "Garapan", "마나가하", "Managaha", "サイパン島"],
  "MP-TIQ": ["티니안섬", "Tinian Island", "티니안 섬", "テニアン島"],
  "MP-ROP": ["로타섬", "Rota Island", "ロタ島"],
  "US-HNL": ["와이키키", "Waikiki", "ワイキキ", "오아후", "Oahu", "O‘ahu", "オアフ島", "火奴鲁鲁", "하와이", "hawaii", "ハワイ", "夏威夷"],
  "US-OGG": ["마우이섬", "Maui Island", "라하이나", "Lahaina", "카훌루이", "Kahului", "マウイ", "毛伊岛"],
  "US-KOA": ["ビッグアイランド", "코나", "Kona", "힐로", "Hilo", "하와이섬", "Hawaii Island", "Hawaiʻi Island"],
  "US-LIH": ["카우아이섬", "Kauai Island", "리후에", "Lihue", "Kauaʻi", "考爱岛", "考艾島"],
};
